module.exports = __webpack_public_path__ + "img/help.21f34c88.svg";